(() => {
  const initialize = () => {
    const handles = new URLSearchParams(window.location.search).getAll('product');
    if (handles.length !== 1 || !/^[a-z0-9][a-z0-9-]{0,254}$/.test(handles[0])) return;

    document.querySelectorAll('[data-pino-product-enquiry]').forEach((field) => {
      const rootUrl = field.dataset.pinoRootUrl;
      if (!/^\/(?:[a-z0-9]+(?:-[a-z0-9]+)*\/?)*$/i.test(rootUrl || '')) return;

      const reference = field.querySelector('[data-pino-product-reference]');
      const submittedReference = field.querySelector('[data-pino-product-submitted-reference]');
      if (!reference || !submittedReference) return;

      const productPath = `${rootUrl.replace(/\/?$/, '/')}products/${handles[0]}`;
      const productUrl = new URL(productPath, window.location.origin).href;
      reference.value = productUrl;
      submittedReference.value = productUrl;
      submittedReference.disabled = false;
      const intent = new URLSearchParams(window.location.search).get('intent');
      const requestType = field.querySelector('[data-pino-product-request-type]');
      const message = field.closest('form')?.querySelector('textarea');
      if ((intent === 'inquiry' || intent === 'hold') && requestType) {
        requestType.value = intent === 'hold' ? 'Reservation request' : 'Product inquiry';
        requestType.disabled = false;
        if (message && !message.value.trim()) {
          message.value = intent === 'hold' ? field.dataset.pinoHoldMessage : field.dataset.pinoInquiryMessage;
        }
      }
      field.hidden = false;
      field.classList.remove('hidden');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
